











































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import DateField from "@/components/misc/DateField.vue";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { DataOptions } from "vuetify";
import { OfficialRateView } from "@/components/property/official-rates/types";
import { ListModel } from "@/shared/models/listModel";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { ServiceType } from "@/shared/models/serviceType";
import FormDescription from "@/components/misc/FormDescription.vue";
import OfficialRatesFormNew from "./OfficialRatesFormNew.vue";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import * as _ from "lodash";
import { Notification } from "@/store/modules/notifications";
import { AccomodationUnitTypeViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import { RatePlan } from "@/components/calendar/CalendarTypes";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";

@Component({
  components: {
    FormDescription,
    RightDrawer,
    OfficialRatesFormNew,
    SortableHeadersTable,
    DateField,
  },
})
export default class OfficialRatesTable extends Vue {
  @Prop() disabled?: boolean;
  @Prop() readonly translateID?: string;
  @Prop() accUnitType?: AccomodationUnitTypeViewModel;

  @Action("appParams/refreshAppParams") refreshAppParams?: () => Promise<void>;

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes") serviceTypes?: ServiceType[];

  @Getter("calendar/nonOBRatePlans") nonOBRatePlans?: RatePlan[];
  @Action("calendar/refreshNonOBRatePlans")
  refreshNonOBRatePlans?: () => Promise<void>;

  items: OfficialRateView[] = [];
  formOpen = false;
  selectedOfficialRate: number | null = null;

  async created() {
    const promises = [];

    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }

    if (
      (this.nonOBRatePlans?.length ?? 0) === 0 &&
      this.refreshNonOBRatePlans
    ) {
      promises.push(this.refreshNonOBRatePlans());
    }

    await Promise.all(promises);

    this.load();

    this.setupHeaders();
  }

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;
  @Getter("appParams/reservationTenantUsesServiceTypes")
  tenantUsesServiceTypes?: boolean;
  @Getter("appParams/officialRatesUseSeasonNames")
  officialRatesUseSeasonNames?: boolean;

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  headers: SortableTableHeader[] = [];

  setupHeaders() {
    this.headers = [
      ...(this.officialRatesUseSeasonNames
        ? [
            {
              text: "OfficialRate.SeasonName",
              value: "seasonName",
              sortable: true,
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      ...(!this.tenantOBRsUseRelativePricing
        ? [
            {
              text: "OfficialRate.RatePlan",
              value: "ratePlanId",
              sortable: true,
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      ...(this.tenantUsesServiceTypes
        ? [
            {
              text: "RatePlan.ServiceType",
              value: "serviceTypeId",
              sortable: true,
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      {
        text: "OfficialRate.DateFrom",
        value: "dateFrom",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header date-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.DateTo",
        value: "dateTo",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header date-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.Price",
        value: "price",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      ...(this.tenantUsesInputPrice
        ? [
            {
              text: "OfficialRate.InputPrice",
              value: "inputPrice",
              sortable: true,
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      {
        text: "OfficialRate.MinimumStay",
        value: "minimumStay",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header min-stay-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.MaximumStay",
        value: "maximumStay",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header min-stay-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.MinBookableBeforeCheckin",
        value: "minBookableBeforeCheckin",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header min-stay-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.MaxBookableBeforeCheckin",
        value: "maxBookableBeforeCheckin",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header min-stay-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.NoDeparturesOn",
        value: "noDeparturesOn",
        sortable: false,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.NoArrivalsOn",
        value: "noArrivalsOn",
        sortable: false,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "OfficialRate.IsMain",
        value: "isMain",
        sortable: true,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  currencyDisplay(amount: number, currencyId: number) {
    const currency = this.currencies?.find((c) => c.id === currencyId);
    return currency
      ? this.$n(amount, {
          style: "currency",
          currency: currency.isoCode,
          currencyDisplay: "code",
        })
      : "";
  }

  serviceTypeDisplay(serviceTypeId: number) {
    if (this.serviceTypes) {
      return this.serviceTypes.find((x) => x.id == serviceTypeId)?.name ?? "";
    }

    return "";
  }

  ratePlanDisplay(ratePlanId: number) {
    if (this.nonOBRatePlans) {
      return this.nonOBRatePlans.find((x) => x.id == ratePlanId)?.name ?? "";
    }

    return "";
  }

  selectedCurrencyDisplay(currencyId: number) {
    if (this.currencies) {
      return this.currencies.find((x) => x.id == currencyId)?.isoCode ?? "";
    }

    return "";
  }

  noDeparturesDisplay(item: OfficialRateView) {
    const days = [];

    if (item.noDeparturesMonday) {
      days.push(this.$t("t.Calendar.MondayShort"));
    }

    if (item.noDeparturesTuesday) {
      days.push(this.$t("t.Calendar.TuesdayShort"));
    }

    if (item.noDeparturesWednesday) {
      days.push(this.$t("t.Calendar.WednesdayShort"));
    }

    if (item.noDeparturesThursday) {
      days.push(this.$t("t.Calendar.ThursdayShort"));
    }

    if (item.noDeparturesFriday) {
      days.push(this.$t("t.Calendar.FridayShort"));
    }

    if (item.noDeparturesSaturday) {
      days.push(this.$t("t.Calendar.SaturdayShort"));
    }

    if (item.noDeparturesSunday) {
      days.push(this.$t("t.Calendar.SundayShort"));
    }

    if (days.length > 0) {
      return days.join(", ");
    }

    return "";
  }

  noArrivalsDisplay(item: OfficialRateView) {
    const days = [];

    if (item.noArrivalsMonday) {
      days.push(this.$t("t.Calendar.MondayShort"));
    }

    if (item.noArrivalsTuesday) {
      days.push(this.$t("t.Calendar.TuesdayShort"));
    }

    if (item.noArrivalsWednesday) {
      days.push(this.$t("t.Calendar.WednesdayShort"));
    }

    if (item.noArrivalsThursday) {
      days.push(this.$t("t.Calendar.ThursdayShort"));
    }

    if (item.noArrivalsFriday) {
      days.push(this.$t("t.Calendar.FridayShort"));
    }

    if (item.noArrivalsSaturday) {
      days.push(this.$t("t.Calendar.SaturdayShort"));
    }

    if (item.noArrivalsSunday) {
      days.push(this.$t("t.Calendar.SundayShort"));
    }

    if (days.length > 0) {
      return days.join(", ");
    }

    return "";
  }

  rowDoubleClick(e: MouseEvent, { item }: { item: OfficialRateView }) {
    this.selectedOfficialRate = item.id;
    this.formOpen = true;
  }

  openItemDetails(item: OfficialRateView) {
    this.selectedOfficialRate = item.id;
    this.formOpen = true;
  }

  addOfficialRate() {
    this.selectedOfficialRate = null;
    this.formOpen = true;
  }

  settingsOpen = false;
  loading = true;
  list: ListModel<OfficialRateView> = {
    count: 0,
    result: [],
  };

  async load(): Promise<ListModel<OfficialRateView>> {
    this.loading = true;
    return this.axios
      .get<ListModel<OfficialRateView>>(
        `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates`,
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!_.isEqual(fresh, old)) {
      this.load();
    }
  }

  filters = {
    seasonName: "",
    dateFromStart: "",
    dateFromEnd: "",
    dateToStart: "",
    dateToEnd: "",
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  debouncedLoad = _.debounce(this.load, 500);

  get dateFromPeriod() {
    const res = [
      this.filters.dateFromStart
        ? this.filters.dateFromStart.substring(0, 10) ?? ""
        : "",
      this.filters.dateFromEnd
        ? this.filters.dateFromEnd.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set dateFromPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.dateFromStart = val.length > 0 ? val[0] : "";
      this.filters.dateFromEnd = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.dateFromStart = "";
      this.filters.dateFromEnd = "";
    }
  }

  get dateToPeriod() {
    const res = [
      this.filters.dateToStart
        ? this.filters.dateToStart.substring(0, 10) ?? ""
        : "",
      this.filters.dateToEnd
        ? this.filters.dateToEnd.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set dateToPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.dateToStart = val.length > 0 ? val[0] : "";
      this.filters.dateToEnd = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.dateToStart = "";
      this.filters.dateToEnd = "";
    }
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
    };
  }

  deleteItem(item: OfficialRateView) {
    const itemName = "'" + (item?.seasonName ?? "") + "'";

    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmationVariable", {
        value: itemName,
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item.id);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteItemConfirm(id: number, overrides: string[] = []) {
    this.loading = true;

    const handleCodes = ["RatePlan.DeleteValidation.OtaSync"];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    Vue.axios
      .delete(
        `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates/${id}`,
        {
          data: { overrideRules: overrides },
          adapter: isOverriding ? undefined : adapter,
        }
      )
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("OfficialRate.DeleteSuccess"),
          timeout: 5000,
        } as Notification);

        this.load();
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.deleteItemConfirm(id, x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
